import React, { useState, useEffect, useContext } from 'react'
import { Editor } from "primereact/editor"
import { BufferService, LoadingContext, M_InputTextField, M_Select, M_Button, M_StateActions, NavigateContext } from 'src/components/M_Components'
import { Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import './settings.css'

export default function CreateTemplate() {
    const dispatch = useDispatch()
    const M_State = useSelector((state) => state.StateKeyValue)
    const [optionsTemplate, setOptionsTemplate] = useState([])
    const [dataTemplate, setDataTemplate] = useState(new Map())
    const [editorTemplate, setEditorTemplate] = useState(new Map())
    const [optionsNotification, setOptionsNotification] = useState([])
    const [id, setId] = useState(M_State.filter(obj => obj.key === 'selectedTab')[0]?.value)
    const [isFirstLoop, setIsFirstLoop] = useState(true)
    const [templateId, setTemplateId] = useState("")
    const [operation, setOperation] = useState("")
    const [optionsLanguage, setOptionsLanguage] = useState([])
    const [count, setCount] = useState(1)

    const bufferServiceTemplateEmail = new BufferService('NotificationTemplate')
    const bufferServiceNotificationType = new BufferService('NotificationType')
    const bufferServiceLanguage = new BufferService('Language')
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const { t } = useTranslation()

    const sessionKeys = ['optionsTemplate', 'dataTemplate', 'editorTemplate', 'optionsNotification', 'templateId', 'operation', 'optionsLanguage', 'count']

    useEffect(() => {
        if (isFirstLoop) {
            ctx.setIsLoad(true)
            getSessionStorageData(id)
            setIsFirstLoop(false)
        }
        // eslint-disable-next-line 
    }, [])

    // eslint-disable-next-line 
    useEffect(() => {
        const newId = M_State.filter(obj => obj.key === 'selectedTab')[0]?.value
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    useEffect(() => {
        const tempArray = []
        sessionKeys.forEach((key) => {
            tempArray.push(sessionStorageMachine(id, key, key))
        })
        dispatch(M_StateActions.addM_State({ key: id, value: tempArray }))
        // eslint-disable-next-line
    }, [id, optionsTemplate, dataTemplate, editorTemplate, optionsNotification, templateId, operation, optionsLanguage, count])

    const sessionStorageMachine = (id, key, value) => {
        let tempObj = {}
        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            tempObj = { key: `${key}`, value: (Array.from(eval(value))) }
        } else {
            // eslint-disable-next-line
            tempObj = { key: `${key}`, value: (eval(value)) }
        }
        return tempObj
    }

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        const M_StateData = M_State.filter(obj => obj.key === sessionID)[0]?.value
        if (M_StateData) {
            const tempOT = M_StateData.filter(obj => obj.key === `optionsTemplate`)[0]?.value
            const tempDT = M_StateData.filter(obj => obj.key === `dataTemplate`)[0]?.value
            const tempET = M_StateData.filter(obj => obj.key === `editorTemplate`)[0]?.value
            const tempON = M_StateData.filter(obj => obj.key === `optionsNotification`)[0]?.value
            const tempTI = M_StateData.filter(obj => obj.key === `templateId`)[0]?.value
            const tempOP = M_StateData.filter(obj => obj.key === `operation`)[0]?.value
            const tempOL = M_StateData.filter(obj => obj.key === `optionsLanguage`)[0]?.value
            const tempCT = M_StateData.filter(obj => obj.key === `count`)[0]?.value
            if (tempOT || tempDT || tempET || tempON || tempTI || tempOP || tempOL || tempCT) {
                setOptionsTemplate(tempOT)
                setDataTemplate(new Map(tempDT))
                setEditorTemplate(new Map(tempET))
                setOptionsNotification(tempON)
                setTemplateId(tempTI)
                setOperation(tempOP)
                setOptionsLanguage(tempOL)
                setCount(tempCT)
                ctx.setIsLoad(false)
                return
            }
        }
        getTemplate()
    }

    const getTemplate = () => {
        const getOperation = ctx.passValue.get('operation')
        const lines = ctx.passValue?.get('lines') || ""
        const getId = lines.Id
        ctx.passValue.delete('operation')
        ctx.passValue.delete('lines')
        ctx.setPassValue(new Map(ctx.passValue))
        setOperation(getOperation)
        setTemplateId(getId)
        ctx.setIsLoad(true)

        if (getOperation === 'create') {
            addFormTemplate()
        }

        bufferServiceNotificationType.get().then((response) => {
            if (response.name === 'AxiosError') {
                ctx.toastMessages('error', response.Message, '')
                return
            }
            setOptionsNotification(response.Items)
        })

        bufferServiceLanguage.get().then((response) => {
            if (response.name === 'AxiosError') {
                ctx.toastMessages('error', response.Message, '')
                return
            }
            setOptionsLanguage(response.Items)
        })

        bufferServiceTemplateEmail.options().then((response) => {
            if (response.name === 'AxiosError') {
                ctx.toastMessages('error', response.Message, '')
                return
            }
            const filteredOptions = response.filter((elem) => elem.IsHiddenList !== true)
            setOptionsTemplate(filteredOptions)

            if (getOperation === 'edit') {
                bufferServiceTemplateEmail.getId(getId).then((test) => {
                    if (test.name === 'AxiosError') {
                        ctx.toastMessages('error', test.Message, '')
                        ctx2.closeTab(id)
                        return
                    }
                    const valueDataTemplate = test

                    let tempId = 0
                    filteredOptions.forEach(obj => {
                        dataTemplate.set(obj.Name, valueDataTemplate[obj.Name])
                    })

                    const tempArray = []
                    valueDataTemplate.TemplateChildList.map(template => {
                        tempId++
                        editorTemplate.set(tempId, template.Body)
                        const tempList = {
                            BeId: template.Id,
                            id: tempId,
                            Subject: template.Subject,
                            Language: template.Language,
                        }
                        tempArray.push(tempList)
                    })
                    setCount(tempId + 1)
                    dataTemplate.set("TemplateChildList", tempArray)
                    setEditorTemplate(new Map(editorTemplate))
                    setDataTemplate(new Map(dataTemplate))
                })
            }
        })
        ctx.setIsLoad(false)
    }

    const templateEmail = (value, name) => {
        dataTemplate.set(name, value)
        setDataTemplate(new Map(dataTemplate))
    }

    const addFormTemplate = () => {
        const newFormTemplate = {
            id: count,
            Subject: '',
            Language: '',
            Body: '',
        }

        setCount((prevCount) => prevCount + 1)

        setDataTemplate((prevDataTemplate) => {
            const updatedTemplates = [...(prevDataTemplate.get("TemplateChildList") || []), newFormTemplate]
            dataTemplate.set("TemplateChildList", updatedTemplates)
            return dataTemplate
        })

        editorTemplate.set(count, '')
        setEditorTemplate(new Map(editorTemplate))
    }

    const updateTemplateField = (name, e, count, data) => {
        const value = e.target.value
        const tempData = { ...data, [name]: value }
        const updatedTemplates = dataTemplate.get('TemplateChildList').map((template) => {
            if (template.id === count) {
                return tempData
            }
            return template
        })
        dataTemplate.set('TemplateChildList', updatedTemplates)
        setDataTemplate(new Map(dataTemplate))
    }

    const deleteTemplate = (id) => {
        if (dataTemplate.get("TemplateChildList").length > 1) {
            const updateTemplate = dataTemplate.get("TemplateChildList").filter(template => template.id !== id)
            dataTemplate.set("TemplateChildList", updateTemplate)
            editorTemplate.delete(id)
            setEditorTemplate(new Map(editorTemplate))
            setDataTemplate(new Map(dataTemplate))
        } else {
            ctx.toastMessages('error', '', t("ErrorDeleteTemplate"))
        }
    }

    const submitTemplate = () => {
        ctx.setIsLoad(true)
        const temp = dataTemplate.get("TemplateChildList")?.map(template => ({
            ...template,
            Body: editorTemplate.get(template.id)
        }))
        const requiredFields = optionsTemplate.filter((elem) => elem.IsRequired)
        for (const field of requiredFields) {
            if (!dataTemplate.has(field.Name) || !dataTemplate.get(field.Name)) {
                ctx.toastMessages('error', field.Name, t("RequiredField"))
                return
            }
        }

        dataTemplate.set("TemplateChildList", temp)
        if (operation === 'edit') {
            setDataTemplate(new Map(dataTemplate))
            bufferServiceTemplateEmail.update(templateId, Object.fromEntries(dataTemplate)).then((response) => {
                if (response.name === "AxiosError") {
                    ctx.toastMessages('error', response.response.data.Errors[0], '')
                    return
                }
                ctx.toastMessages("success", '', t("SuccessAddedTemplate"))
                ctx2.closeTab(id)
                ctx.setIsLoad(false)
            })
        } else {
            bufferServiceTemplateEmail.post(Object.fromEntries(dataTemplate)).then((response) => {
                if (response.name === "AxiosError") {
                    ctx.toastMessages('error', response.response.data.Errors[0], '')
                    return
                }
                ctx.toastMessages("success", '', t("SuccessAddedTemplate"))
                ctx2.closeTab(id)
                ctx.setIsLoad(false)
            })
        }
    }

    return (
        <div className='backgroundForms'>
            <div className="display">
                <div className="menuIcon">
                    <Tooltip title={t("Back")} className='iconsHeaderTable'>
                        <div className='iconsHeaderTable' onClick={() => ctx2.closeTab(id)}>
                            <i className="pi pi-arrow-left iconTable"></i>
                            <span className='labelCRUDTable'><b>{t("Back")}</b></span>
                        </div>
                    </Tooltip>
                    <Tooltip title={t("Save")}>
                        <div className='iconsHeaderTable' onClick={submitTemplate}>
                            <i className="pi pi-save iconTable"></i>
                            <span className='labelCRUDTable'><b>{t("Save")}</b></span>
                        </div>
                    </Tooltip>
                </div>
            </div>
            <div className='dividerMenu'></div>
            <div className='divDisplayFormTemplate'>
                {optionsTemplate.map((elem) => (
                    <div key={elem.Name}>
                        {elem.Type === 'string' ? (
                            elem.Name === 'NotificationTypeName' ?
                                <M_Select
                                    label={elem.NormalizedName}
                                    value={dataTemplate.get(elem.Name) || ""}
                                    options={optionsNotification.map((value) => ({
                                        label: value.Name,
                                        value: value.Name
                                    }))}
                                    required={elem.IsRequired}
                                    onChange={(e) => {
                                        templateEmail(e.target.value, elem.Name)
                                    }}
                                />
                                :
                                <M_InputTextField
                                    label={elem.NormalizedName}
                                    required={elem.IsRequired}
                                    onChange={(e) => templateEmail(e.target.value, elem.Name)}
                                    value={dataTemplate.get(elem.Name) || ""}
                                />
                        ) : (elem.Type === 'int32' ? (
                            <M_InputTextField
                                type={"number"}
                                label={elem.NormalizedName}
                                required={elem.IsRequired}
                                onChange={(e) => templateEmail(e.target.value, elem.Name)}
                                value={dataTemplate.get(elem.Name) || ""}
                            />
                        ) : "")}
                    </div>
                ))}
            </div>

            <div className='divAlignButtonAddTemplate'>
                <M_Button
                    label={"Add New Template"}
                    labelColor={'var(--color-black)'}
                    icon={<img src="/icons/svgsDaNet/mail.svg"
                        style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)', width: '24px' }}
                        alt="save" />
                    }
                    borderColor={'var(--color-grey)'}
                    onClick={addFormTemplate}
                />

            </div>

            <div className='divFormInterior'>
                <div className='divLabelName'>Templates</div>
                <div className='divGridFormTemplate'>
                    {dataTemplate.get("TemplateChildList")?.map((template, index) => (
                        <div key={index} className='heightTemplate'>
                            <div className='divAlignFormTemplate'>
                                <M_InputTextField
                                    label={"Subject"}
                                    required={true}
                                    value={template.Subject || ""}
                                    onChange={(e) => updateTemplateField("Subject", e, template.id, template)}
                                />
                                <M_Select
                                    label={"Language"}
                                    options={optionsLanguage.map((option) => ({
                                        label: option.Name,
                                        value: option.Name,
                                    }))}
                                    value={template.Language || "" || ""}
                                    onChange={(e) => updateTemplateField("Language", e, template.id, template)}
                                    required={true}
                                />

                            </div>
                            <div className='divDeleteTemplate'>
                                <M_Button
                                    label={"Remove Template"}
                                    labelColor={'var(--color-black)'}
                                    icon={<img src="/icons/svgsDaNet/trash-2.svg"
                                        style={{ filter: 'invert(11%) sepia(68%) saturate(6715%) hue-rotate(359deg) brightness(93%) contrast(115%)', width: '24px' }}
                                        alt="save" />
                                    }
                                    borderColor={'var(--color-grey)'}
                                    onClick={(e) => deleteTemplate(template.id)}
                                />
                            </div>
                            <Editor
                                value={editorTemplate.get(template.id) || ""}
                                onTextChange={(e) => setEditorTemplate(new Map(editorTemplate.set(template.id, e.htmlValue)))}
                                className='editor'
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}